import * as React from "react";
const ProfileFill = (props) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.857 0H6.47699C2.83699 0 0.666992 2.17 0.666992 5.81V14.19C0.666992 17 1.95699 18.93 4.22699 19.66C4.88699 19.89 5.64699 20 6.47699 20H14.857C15.687 20 16.447 19.89 17.107 19.66C19.377 18.93 20.667 17 20.667 14.19V5.81C20.667 2.17 18.497 0 14.857 0ZM19.167 14.19C19.167 16.33 18.327 17.68 16.637 18.24C15.667 16.33 13.367 14.97 10.667 14.97C7.96699 14.97 5.67699 16.32 4.69699 18.24H4.68699C3.01699 17.7 2.16699 16.34 2.16699 14.2V5.81C2.16699 2.99 3.65699 1.5 6.47699 1.5H14.857C17.677 1.5 19.167 2.99 19.167 5.81V14.19Z"
      fill="#276AA6"
    />
    <path
      d="M10.6671 4.51514C8.27705 4.51514 6.3457 6.44649 6.3457 8.83653C6.3457 11.2266 8.27705 13.17 10.6671 13.17C13.0571 13.17 14.9885 11.2266 14.9885 8.83653C14.9885 6.44649 13.0571 4.51514 10.6671 4.51514Z"
      fill="#276AA6"
    />
  </svg>
);
export default ProfileFill;
